import React, { Component, Children } from "react"
import Relay from "react-relay"
import { Link } from "react-router"
import Helmet from "react-helmet"
import { FormattedMessage, injectIntl } from "react-intl"
import Icon from "./elements/Icon"
import Header from "./modules/Header"
import { getPageMeta } from "../scripts/utils"
import { default as sharedMessages } from "../messages/index"
import { default as footerMessages } from "../messages/footer"
import settingsMessages from "../messages/settings"

import { getAccountSettings } from "../scripts/accountSettings"
import { getStyles, getStyleTag } from "../styles/dynamicStyles"

// const year = new Date().getFullYear()
class Layout extends Component {
  render() {
    const {
      location: { pathname },
      intl,
      viewer: {
        resources: { edges: resourceEdges }
      }
    } = this.props
    const {
      name: title,
      settings: {
        style: { footer: styleFooterType, content: styleBodyType },
        footer_pages: footerPages,
        twitter_handle: twitterHandle,
        instagram_handle: instagramHandle,
        facebook_handle: facebookHandle,
        contact_email: contactEmail,
        copyright
      },
      og_image: ogImage
    } = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    const resources = resourceEdges.map(edge => edge.node)

    return (
      <div>
        <Helmet
          title={title}
          titleTemplate={`%s - ${title}`}
          meta={getPageMeta({
            title,
            image: ogImage ? ogImage.url : null
          })}
        />
        <a className="skip-to-content-link" href="#main">
          {getStyleTag("skip-to-content-link")}
          <FormattedMessage {...footerMessages.skipToContent} />
        </a>

        <Header pathname={pathname} resources={resources} />

        <div className={`main-wrapper ${styleBodyType}`}>
          {Children.only(this.props.children)}
        </div>

        <footer
          className={`site-footer ${styleFooterType}`}
          role="contentinfo"
          style={getStyles("site-footer")}
        >
          <div
            className="site-footer-inner"
            style={getStyles("site-footer-inner")}
          >
            {getStyleTag([
              "site-footer-inner",
              "site-footer__nav--social",
              "site-footer__col",
              "site-footer__nav-link"
            ])}
            {styleFooterType !== "default" ? (
              <div
                className="site-footer__col site-footer__col--copyright"
                style={getStyles([
                  "site-footer__col",
                  "site-footer__col--copyright"
                ])}
              >
                <p style={getStyles("site-footer__col--copyright-p")}>
                  {copyright || ""}
                </p>
              </div>
            ) : null}
            <div
              className="site-footer__col site-footer__col--nav"
              style={getStyles("site-footer__col")}
            >
              <nav
                className="site-footer__nav"
                role="menu"
                style={getStyles("site-footer__nav")}
              >
                {footerPages
                  ? footerPages.map((item, key) => {
                      if (!item.source_id) {
                        return null
                      }

                      const props = {
                        id: `footer.${item.source_id}`,
                        defaultMessage: item.title
                      }

                      return (
                        <Link
                          key={key}
                          to={`/${item.source_id}`}
                          className="site-footer__nav-link"
                          style={getStyles("site-footer__nav-link")}
                          href="#"
                          role="menuitem"
                        >
                          <FormattedMessage {...props} />
                        </Link>
                      )
                    })
                  : null}
              </nav>
            </div>
            <div
              className="site-footer__col site-footer__col--social-copyright"
              style={getStyles("site-footer__col")}
            >
              <ul
                className="site-footer__nav site-footer__nav--social"
                style={getStyles("site-footer__nav")}
                role="menu"
              >
                {twitterHandle && (
                  <li>
                    <a
                      className="site-footer__nav-link"
                      href={`https://twitter.com/${twitterHandle}`}
                      target="_blank"
                      role="menuitem"
                    >
                      <Icon
                        icon="twitter-circle"
                        title={intl.formatMessage(sharedMessages.findTwitter)}
                      />
                    </a>
                  </li>
                )}
                {instagramHandle && (
                  <li>
                    <a
                      className="site-footer__nav-link"
                      href={`https://www.instagram.com/${instagramHandle}`}
                      target="_blank"
                      role="menuitem"
                    >
                      <Icon
                        icon="instagram-circle"
                        title={intl.formatMessage(sharedMessages.findInstagram)}
                      />
                    </a>
                  </li>
                )}
                {facebookHandle && (
                  <li>
                    <a
                      className="site-footer__nav-link"
                      href={`https://www.facebook.com/${facebookHandle}`}
                      target="_blank"
                      role="menuitem"
                    >
                      <Icon
                        icon="facebook-circle"
                        title={intl.formatMessage(sharedMessages.findFacebook)}
                      />
                    </a>
                  </li>
                )}
                {contactEmail && (
                  <li>
                    <a
                      className="site-footer__nav-link"
                      href={`mailto:${contactEmail}`}
                      role="menuitem"
                    >
                      <Icon
                        icon="email-circle"
                        title={intl.formatMessage(sharedMessages.findEmail)}
                      />
                    </a>
                  </li>
                )}
                {/*<li><a className="site-footer__nav-link" href="#" role="menuitem"><Icon icon="youtube-circle" title="Find us on Youtube" /></a></li>
                              <li><a className="site-footer__nav-link" href="#" role="menuitem"><Icon icon="flickr-circle" title="Find us on Flickr" /></a></li>*/}
              </ul>
              {styleFooterType === "default" ? <p>{copyright || ""}</p> : null}
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default Relay.createContainer(injectIntl(Layout), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        resources(
          first: 40
          type: "onboarding_step OR notification"
          access_rights: "published"
          order: "position"
          direction: "asc"
        ) {
            edges {
              node {
                id
                title
                type
                custom_fields
                created_at
                creator
                position
                files {
                  id
                  type
                  images {
                    small { url width }
                    medium { url width }
                    large { url width }
                  }
                }
              }
            }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/Layout.js